export const MAX_SHORT_TEXT = 75;
